import React, {useState, useContext} from "react"
import PropTypes from "prop-types"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

// context 
import {ShopContext} from "../../../context"

// components
import {Redirect} from "react-router-dom"
import {Button} from "./../../controls"

// styling and icons
import "./Console.scss"
import {faAngleLeft, faAngleRight} from "@fortawesome/free-solid-svg-icons";

// definition of steps used to display navigation buttons
const steps = {
  cart: { 
    previous:"search", 
    next:"checkout/packaging", 
    previousLabel:"Erlebnisse",
    previousButtonKind:"ok-secondary",
    nextLabel:"Verpackung",
    title:"Warenkorb & Promocode",
    description:"Hier kannst du deinen Warenkorb anpassen und eine Promocode eingeben."
  },
  packaging: { 
    previous:"checkout/cart", 
    next:"checkout/personalize", 
    nextLabel:"personalisieren",
    title:"Verpackung wählen",
    description:"Wähle eine Verpackung."
  },
  personalize: {
    previous:"checkout/packaging",
    next:"checkout/payment", 
    nextLabel:"Zahlungsart wählen",
    title:"Zahlungsart",
    description:"Sag uns, wie du das Geschenk bezahlen möchtest"
  },
  payment: {
    previous:"checkout/personalize",
    next:"checkout/confirm",
    nextLabel:"letzter Check",
    title:"Personalisieren das Geschenk",
    description:"Hier kannst du bestimmen, was auf dem Gutschein stehen soll."
  },
  confirm: {
    previous:"checkout/payment",
    next:null,
    nextLabel:"Bestellung abschliessen",
    title:"Letzer Check",
    description:"Überprüfe noch mal alles."
  }
}

// the component
function Console({stepName, onClickNext, onClickPrevious, showValidation}) {
  // context
  let shop = useContext(ShopContext)

  // state management
  const [redirect, setRedirect] = useState(null)

  // get the step we are currently at
  let step = steps[stepName]

  // redirect?
  if(redirect) {
    return <Redirect to={`/${redirect}`} />
  }
  
  // buttons depending on state
  let buttonPrevious = null
  if(step.previous) {
    //buttonPrevious = <Button kind={step.previousButtonKind || "ok"} label={step.previousLabel || "<"} onClick={() => setRedirect(step.previous)} />
    buttonPrevious = <Button kind={step.previousButtonKind || "ok"} onClick={() => setRedirect(step.previous)}>
      <FontAwesomeIcon icon={faAngleLeft} />{step.previousLabel ? ` ${step.previousLabel}`: ""}
    </Button>
  }
  // TODO #NotDry we check for validity here and in checkout/CheckoutNavigator ... 
  let nextDisabled = false
  switch(stepName) {
    case "cart":
      nextDisabled = shop.cartValidation.activities === false
      break
    case "personalize":
        nextDisabled = shop.cartValidation.personalization === false
      break
    case "payment":
        nextDisabled = shop.cartValidation.payment === false
      break
    case "confirm":
      nextDisabled = shop.cartValidation.valid === false
      break
    default:
      nextDisabled = false
  }
  let buttonNext = null
  if(onClickNext) {
    buttonNext = <Button onClick={onClickNext} disabled={nextDisabled}><span>{step.nextLabel}</span> <FontAwesomeIcon icon={faAngleRight} /></Button>
  }
  else if(step.next) {
    buttonNext = <Button onClick={() => setRedirect(step.next)} disabled={nextDisabled}><span>{step.nextLabel}</span> <FontAwesomeIcon icon={faAngleRight} /></Button>
  }
  
  // validation message
  // NOTE: there was a time when we displayed the validation in the console ... hardcoding the showValidation value to false and leaving this code in here, just in case we change our mind
  let validationMessage = null
  /*
  let cartValidation = shop.cartValidation
  let isValid = true
  let message =  null
  switch(stepName) {
    case "payment":
      isValid = cartValidation.payment
      if(!isValid) {
        message = cartValidation.paymentMessage
      }
      break
    case "personalize":
      isValid = cartValidation.personalization
      if(!isValid) {
        message = cartValidation.personalizationMessage
      }
      break
    case "confirm":
      isValid = cartValidation.valid
      message = `Die Bestellung kann nicht abgeschlossen werden: ${cartValidation.errors.join(', ')}`
      break
    default:
      break
  }

  if(!isValid && showValidation) {
    validationMessage = (
      <div className="validationMessage">
        <Warning text={message} />
      </div>
    )
  }
  */
  
  // render (Note: we deal with the Virtual Keyboard on Android devices with a media query that hides the validation message and list ... see Console.scss)
  return (
    <>
    <div className="s-checkout-console">
      {validationMessage}
      <div className="navigate">
          {buttonPrevious}
          {buttonNext}
      </div>
    </div>
    </>
  )
}

Console.propTypes = {
  stepName:PropTypes.string.isRequired,
  showValidation:PropTypes.bool.isRequired,
  onClickNext:PropTypes.func, 
}

Console.defaultProps = {
  showValidation:true
}

export default Console